<template>
    <div>
        <v-btn
            @click="
                $router.replace(
                    store.state.user.role == 'admin'
                        ? '/admin/dashboard'
                        : '/dashboard'
                )
            "
            outlined
            ><v-icon>fas fa-arrow-left</v-icon></v-btn
        >
        <v-container>
            <p>Username: {{ schedule.username }}</p>
            <v-simple-table style="border:solid;padding:8px">
                <thead>
                    <tr>
                        <th style="font-size:20px">Tid</th>
                        <th style="font-size:20px">Kommentarer</th>
                        <th v-for="date in dates" :key="date.id">
                            <p
                                style="font-size:30px;color:white;background-color:orange;max-width:130px;border-radius:5px;padding:2px"
                            >
                                {{ toDDMMYY(date.schedule_date) }}
                            </p>
                            <p style="font-size:15px">
                                {{ toMMHH(date.time_from) }} to
                                {{ toMMHH(date.time_to) }}
                            </p>
                        </th>
                        <th
                            v-for="det in contact"
                            v-show="det && schedule.ask_for_contact == 'yes'"
                            :key="det"
                        >
                            {{ det }}
                        </th>
                    </tr>
                    <tr>
                        <th style="font-size:20px">Deltagarens namn</th>
                    </tr>
                    <tr
                        v-for="participant in participation_table"
                        :key="participant.id"
                    >
                        <td>{{ participant.name }}</td>
                        <td>{{ participant.comment }}</td>
                        <td v-for="date in participant.dates" :key="date.id">
                            <p v-if="date.status == 1">
                                <v-icon style="margin-left:10px;color:green"
                                    >fas fa-check</v-icon
                                >
                            </p>
                            <p v-else-if="date.status == 0">
                                <v-icon style="margin-left:10px;color:red"
                                    >fas fa-times</v-icon
                                >
                            </p>
                            <p v-else>Om det behövs</p>
                            <p>{{ date.comment }}</p>
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci0 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci1 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci2 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci3 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci4 }}
                        </td>
                    </tr>
                </thead>
            </v-simple-table>
            <v-row
                style="text-align:center;margin-top:30px"
                v-show="store.state.user.role == 'admin'"
            >
                <v-col>
                    <div>
                        <p>
                            Endast Admin<v-icon
                                style="margin-left:10px;color:green"
                                v-if="store.state.schedule.adminOnly"
                                >fas fa-check</v-icon
                            ><v-icon style="margin-left:10px;color:red" v-else
                                >fas fa-times</v-icon
                            >
                        </p>
                        <p>
                            Enstaka svar<v-icon
                                style="margin-left:10px;color:green"
                                v-if="store.state.schedule.oneAns"
                                >fas fa-check</v-icon
                            ><v-icon style="margin-left:10px;color:red" v-else
                                >fas fa-times</v-icon
                            >
                        </p>
                        <p>
                            Kontaktinfo<v-icon
                                style="margin-left:10px;color:green"
                                v-if="store.state.schedule.contactInfo"
                                >fas fa-check</v-icon
                            ><v-icon style="margin-left:10px;color:red" v-else
                                >fas fa-times</v-icon
                            >
                        </p>
                    </div>
                </v-col>
                <v-col
                    ><p>
                        Dold schema<v-icon
                            style="margin-left:10px;color:green"
                            v-if="store.state.schedule.hidSchedule"
                            >fas fa-check</v-icon
                        ><v-icon style="margin-left:10px;color:red" v-else
                            >fas fa-times</v-icon
                        >
                    </p>
                    <p>
                        Sätt en deadline för svar:
                        <v-icon
                            style="margin-left:10px;color:green"
                            v-if="schedule.deadlineReply"
                            >fas fa-check</v-icon
                        ><v-icon style="margin-left:10px;color:red" v-else
                            >fas fa-times</v-icon
                        >
                    </p>
                    <p v-show="schedule.deadlineReply">
                        Deadline Datum:
                        {{ schedule.deadlineDate }}
                    </p>
                </v-col>
            </v-row>
            <v-btn v-clipboard="copyLink" text>
                <v-icon>fas fa-share-alt</v-icon>
            </v-btn>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import store from "../store";
export default {
    data: function() {
        return {
            store: store,
            id: this.$route.params.id,
            schedule: {},
            dates: [],
            participants: [],
            participant_dates: [],
            participation_table: [],
            name: "",
            selectedDates: [],
            comment: "",
            email: null,
            phone: null,
            shareLink: `https://tid.nu/schedule/`,
            link: "",
            ifNeeded: ""
        };
    },
    created: async function() {
        var bodyForm = new FormData();
        bodyForm.set("link", this.link);
        var config = {
            method: "get",
            url: `${this.store.state.baseURL}showschedule/${this.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.schedule = resp.data.schedule[0];
        this.link = this.schedule.schedule_link;
        this.ifNeeded = this.schedule.if_needed_option;
        this.dates = resp.data.time;
        this.participants = resp.data.participants;
        this.shareLink += this.link;
        this.participant_dates = resp.data.participants_date;
        for (var i = 0; i < this.participants.length; i++) {
            var participant = {
                id: i,
                name: this.participants[i].name,
                comment: this.participants[i].comment,
                email: this.participants[i].email,
                phone: this.participants[i].phone,
                dates: []
            };
            for (var j = 0; j < this.participant_dates.length; j++) {
                if (
                    this.participants[i].id ===
                    this.participant_dates[j].participant_id
                )
                    participant.dates.push({
                        date: this.participant_dates[j].id,
                        status: this.participant_dates[j].participant_status,
                        comment: this.participant_dates[j].comment
                    });
            }
            this.participation_table = [
                ...this.participation_table,
                participant
            ];
            participant = { id: 0, name: "", dates: [] };
        }
        for (i = 0; i < this.dates.length; i++) {
            this.selectedDates[i] = { id: this.dates[i].id, status: false };
        }
        this.contact = [
            this.schedule[0].contact_info1,
            this.schedule[0].contact_info2,
            this.schedule[0].contact_info3,
            this.schedule[0].contact_info4,
            this.schedule[0].contact_info5
        ];
    },
    methods: {
        copyLink: function() {
            return this.shareLink;
        },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
        toMMHH(time) {
            return time.substring(0, 5);
        }
    }
};
</script>

<style></style>
